type NetsuiteStoreID =
  | 1
  | 2
  | 3
  | 10
  | 27
  | 31
  | 32
  | 33
  | 34
  | 35
  | 59
  | 60
  | 61
  | 62
  | 67
  | 68
  | 65
  | 66
  | null

/**
 * It returns the Netsuite [VEL-INT] Store ID number relative to the current store.
 * If the current store is not a Velasca store, it returns null.
 *
 * @param domain - The current store domain.
 * @returns The Store ID.
 */

export const getStoreNetsuiteId = (domain: string): NetsuiteStoreID => {
  switch (domain) {
    case 'velasca-beta.myshopify.com': {
      return 1
    }
    case 'velasca.myshopify.com': {
      return 2
    }
    case 'eu-velasca.myshopify.com': {
      return 3
    }
    case 'us-velasca.myshopify.com': {
      return 67
    }
    case 'row-velasca.myshopify.com': {
      return 65
    }
    case 'uk-velasca.myshopify.com': {
      return 10
    }
    case 'fr-velasca.myshopify.com': {
      return 27
    }
    case 'de-velasca.myshopify.com': {
      return 59
    }
    case 'dk-velasca.myshopify.com': {
      return 61
    }
    case 'velasca-woman-beta.myshopify.com': {
      return 31
    }
    case 'velasca-woman.myshopify.com': {
      return 32
    }
    case 'eu-velasca-woman.myshopify.com': {
      return 33
    }
    case 'uk-velasca-woman.myshopify.com': {
      return 35
    }
    case 'fr-velasca-woman.myshopify.com': {
      return 34
    }
    case 'de-velasca-woman.myshopify.com': {
      return 60
    }
    case 'dk-velasca-woman.myshopify.com': {
      return 62
    }
    case 'us-velasca-woman.myshopify.com': {
      return 68
    }
    case 'row-velasca-woman.myshopify.com': {
      return 66
    }
    default: {
      return null
    }
  }
}
